import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import axios from '../services/axiosConfig';

const CommunicationLimitSettings = ({ organizations, onSaved }) => {
  const [limits, setLimits] = useState({});
  const [savingId, setSavingId] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setLimits(Object.fromEntries(organizations.map((row) => [row.organization.id, {
      smsSegments: row.limits.smsSegments || '',
      emailMessages: row.limits.emailMessages || '',
    }])));
  }, [organizations]);

  const updateLimit = (organizationId, field, value) => {
    setLimits((current) => ({
      ...current,
      [organizationId]: { ...current[organizationId], [field]: value },
    }));
  };

  const save = async (organizationId) => {
    try {
      setSavingId(organizationId);
      setMessage('');
      await axios.put(`/api/communication-analytics/organizations/${organizationId}/limits`, limits[organizationId]);
      setMessage('Limits saved.');
      await onSaved();
    } catch (error) {
      setMessage(error.response?.data?.error || 'Failed to save limits.');
    } finally {
      setSavingId(null);
    }
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700}>Church usage limits</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>Set a 30-day warning threshold for each church. Leave a field blank to track without a limit.</Typography>
      {message && <Alert severity={message === 'Limits saved.' ? 'success' : 'error'} sx={{ mb: 2 }}>{message}</Alert>}
      <Stack spacing={1.5}>
        {organizations.map((row) => (
          <Paper key={row.organization.id} variant="outlined" sx={{ p: 2 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ md: 'center' }} gap={2}>
              <Typography fontWeight={700} sx={{ flex: 1 }}>{row.organization.name}</Typography>
              <TextField size="small" type="number" label="SMS segment limit" value={limits[row.organization.id]?.smsSegments || ''} onChange={(event) => updateLimit(row.organization.id, 'smsSegments', event.target.value)} inputProps={{ min: 1 }} />
              <TextField size="small" type="number" label="Email send limit" value={limits[row.organization.id]?.emailMessages || ''} onChange={(event) => updateLimit(row.organization.id, 'emailMessages', event.target.value)} inputProps={{ min: 1 }} />
              <Button variant="outlined" onClick={() => save(row.organization.id)} disabled={savingId === row.organization.id}>Save</Button>
            </Stack>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
};

export default CommunicationLimitSettings;
